import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search-section-toggle',
  templateUrl: './search-section-toggle.component.html',
  styleUrls: ['./search-section-toggle.component.scss']
})
export class SearchSectionToggleComponent implements OnInit {
  @Input() closeStatus = false;
  @Output() closeStatusChange = new EventEmitter<boolean>();
  clickPostionY: number;
  constructor() {}

  ngOnInit() {}
  toggle(e: MouseEvent) {
    if (this.clickPostionY === e.y) {
      this.closeStatus = !this.closeStatus;
      this.closeStatusChange.emit(this.closeStatus);
    }
  }
  setClickPosition(e: MouseEvent) {
    this.clickPostionY = e.y;
  }
}
